import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Actif } from 'app/models/Actif';
import { Dividende } from 'app/models/Dividende';
import { MarketData } from 'app/models/MarketData';
import { environment } from 'environments/environment';
import type { LineData, Time } from 'lightweight-charts';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class DataService {
    serveur_name = environment.serveur_name;
    host_name = environment.data_host;
    private dataUrl = this.host_name + '/api/data';
    private dataPrincipaux = this.host_name + '/api/data/principaux';
    private dataIndices = this.host_name + '/api/data/indices';
    private ActifUrl = this.host_name + '/api/actifs';
    private miniChartUrl = this.host_name + '/api/data/history/mini';
    private DividendeUrl = this.host_name + '/api/dividendes';

    token: string;

    constructor(private http: HttpClient) {}

    recupererTout(): Observable<MarketData[]> {
        return this.http.get<MarketData[]>(this.dataUrl);
    }

    recupererPrincipaux(): Observable<MarketData[]> {
        return this.http.get<MarketData[]>(this.dataPrincipaux);
    }

    recupererIndices(): Observable<MarketData[]> {
        return this.http.get<MarketData[]>(this.dataIndices);
    }

    recupererParISIN(isin: string): Observable<MarketData> {
        return this.http.get<MarketData>(`${this.dataUrl}/${isin}`);
    }

    recupererActifs(): Observable<Actif[]> {
        return this.http.get<Actif[]>(this.ActifUrl);
    }

    recupererActifParNom(nom: string): Observable<Actif> {
        return this.http.get<Actif>(`${this.ActifUrl}/${nom}`);
    }
    recupererMiniChart(
        symbol: string,
        resolution: string,
        to: number,
        countback: number
    ): Observable<{
        s: string;
        data: LineData<Time>[];
    }> {
        const params = new HttpParams()
            .set('symbol', symbol)
            .set('resolution', resolution)
            .set('to', to.toString())
            .set('countback', countback.toString());
        return this.http.get<{
            s: string;
            data: LineData<Time>[];
        }>(this.miniChartUrl, { params });
    }

    recupererActifHistory(
        symbol: string,
        resolution: string,
        to: number,
        countback: number
    ): Observable<any> {
        const params = new HttpParams()
            .set('symbol', symbol)
            .set('resolution', resolution)
            .set('to', to.toString())
            .set('countback', countback.toString());
        return this.http.get<any>(this.dataUrl + '/history', { params });
    }
    getDividendes(): Observable<Dividende[]> {
        return this.http.get<Dividende[]>(this.DividendeUrl);
    }
    getDividendesById(id: string): Observable<Dividende> {
        return this.http.get<Dividende>(`${this.DividendeUrl}/${id}`);
    }
    getDividendesByIsin(isin: string): Observable<Dividende> {
        return this.http.get<Dividende>(`${this.DividendeUrl}/isin/${isin}`);
    }
}
